<main #simulatorContainer class="simulator" aria-label="Simulador Comissionamento – Segmento Varejo">
  <header class="simulator-header">
    <div class="header-controls" aria-label="Filtros do período">
      <app-exercise-calendar
        [initialYear]="selectedYear"
        [initialMonth]="selectedMonth"
        [disableEvenMonths]="true"
        (periodChange)="onPeriodChange($event)">
      </app-exercise-calendar>
      <app-export-document-button
        [disabled]="isExporting"
        [canChoose]="true"
        [availableMonths]="availableExportMonths"
        [initialStartYear]="selectedYear"
        [initialStartMonth]="selectedMonth"
        [initialEndYear]="selectedYear"
        [initialEndMonth]="selectedMonth"
        (exportPdfModal)="onExportRequested()"
        (exportExcelModal)="onExcelExportRequested($event)"
        class="export-button">
      </app-export-document-button>
      <button
        class="mode-control"
        type="button"
        [disabled]="isExporting"
        aria-label="Mostrar ou ocultar a matriz Penetration/ISR"
        aria-controls="penetration-table"
        [attr.aria-expanded]="isPenetrationVisible"
        (click)="togglePenetrationTable()">
        Penetration/ISR
      </button>
    </div>
  </header>

  <div class="dashboard-grid">
    <section class="panel realized-panel">
      <div class="panel-heading realized-heading">
        <div class="panel-heading-copy">
          <h2 class="panel-title">
            Realizado do Grupo
            <span
              class="tooltip-trigger"
              role="img"
              tabindex="0"
              aria-label="Tooltip Realizado: Abra a sessão para verificar o resultado médio do período real DN"
              aria-describedby="realized-tooltip">
              <span class="info-icon" aria-hidden="true">i</span>
              <span class="realized-tooltip" id="realized-tooltip" aria-hidden="true">
                Abra a sessão para verificar o resultado médio do período real DN
              </span>
            </span>
          </h2>
          <p class="panel-subtitle">Resultado médio do período atual 16 de maio de 2026 a 15 de novembro de 2026</p>
        </div>
      </div>

      <div class="table-scroll">
        <table class="realized-table">
          <thead>
            <tr>
              <th scope="col"></th>
              <th scope="col">Novos</th>
              <th scope="col">Usados</th>
              <th scope="col">Total</th>
            </tr>
          </thead>
          <tbody>
            @for (row of realizedRows; track row.label) {
              <tr>
                <th scope="row">{{ row.label }}</th>
                <td>{{ row.newVehicles }}</td>
                <td>{{ row.usedVehicles }}</td>
                <td>{{ row.total }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </section>

    <section class="panel closing-panel">
      <div class="panel-heading">
        <div class="panel-heading-copy">
          <h2 class="panel-title">Simular o Fechamento</h2>
          <p class="panel-subtitle">Campos editáveis (% ou vol)</p>
        </div>
      </div>

      <div class="table-scroll">
        <table class="closing-table">
          <thead>
            <tr>
              <th scope="col"></th>
              <th scope="col">Novos</th>
              <th scope="col">Usados</th>
              <th scope="col">Total</th>
            </tr>
          </thead>
          <tbody>
            @for (row of visibleClosingPeriodRows; track row.label) {
              <tr>
                <th scope="row">{{ row.label }}</th>
                @for (value of [row.newVehicles, row.usedVehicles, row.total]; track $index) {
                  <td>
                    @if ($index < 2 && !row.totalEditable && row.inputType) {
                      <span class="closing-input-shell" [class.input-updated]="isInputUpdated(row, $index === 0 ? 'newVehicles' : 'usedVehicles')">
                        <input
                          class="closing-input"
                          type="text"
                          inputmode="decimal"
                          [value]="value"
                          [attr.data-row-label]="row.label"
                          [attr.data-field]="$index === 0 ? 'newVehicles' : 'usedVehicles'"
                          [attr.aria-label]="row.label + ' - ' + ($index === 0 ? 'Novos' : 'Usados')"
                          (input)="updateClosingInput(row, $index === 0 ? 'newVehicles' : 'usedVehicles', $event)">
                        @if (row.inputType === 'percentage') {
                          <span class="input-suffix" aria-hidden="true">%</span>
                        }
                      </span>
                    } @else if ($index === 2 && row.totalEditable) {
                      <span class="closing-input-shell" [class.input-updated]="isInputUpdated(row, 'total')">
                        <input
                          class="closing-input"
                          type="text"
                          inputmode="decimal"
                          [value]="value"
                          [attr.data-row-label]="row.label"
                          data-field="total"
                          [attr.aria-label]="row.label + ' - Total'"
                          (input)="updateClosingInput(row, 'total', $event)">
                        @if (row.inputType === 'percentage') {
                          <span class="input-suffix" aria-hidden="true">%</span>
                        }
                      </span>
                    } @else {
                      {{ value }}
                    }
                  </td>
                }
              </tr>
            }
          </tbody>
        </table>
      </div>
    </section>

    <section class="panel new-period-panel">
      <div class="panel-heading">
        <div class="panel-heading-copy">
          <h2 class="panel-title">Nova comissão simulada</h2>
          <p class="panel-subtitle">Resultado do novo período</p>
        </div>
      </div>

      <div class="table-scroll">
        <table class="new-period-table">
          <thead>
            <tr>
              <th scope="col"></th>
              <th scope="col">Novos</th>
              <th scope="col">Usados</th>
              <th scope="col">Total</th>
            </tr>
          </thead>
          <tbody>
            @for (row of newPeriodRows; track row.label) {
              <tr>
                <th scope="row">{{ row.label }}</th>
                <td>{{ row.newVehicles }}</td>
                <td>{{ row.usedVehicles }}</td>
                <td>{{ row.total }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </section>

    <footer class="commission-summary" aria-label="Resumo de comissão">
      <div class="summary-item">
        <span class="summary-label">Média Regional</span>
        <strong>
          {{ regionalAverageDisplay }}
          @if (regionalTrend) {
            <span
              class="trend"
              [class.trend-up]="regionalTrend.direction === 'up'"
              [class.trend-down]="regionalTrend.direction === 'down'">
              {{ regionalTrend.direction === 'up' ? '↑' : '↓' }} {{ regionalTrend.value }}
            </span>
          }
        </strong>
      </div>
      <div class="summary-item">
        <span class="summary-label">Média Nacional</span>
        <strong>
          {{ nationalAverageDisplay }}
          @if (nationalTrend) {
            <span
              class="trend"
              [class.trend-up]="nationalTrend.direction === 'up'"
              [class.trend-down]="nationalTrend.direction === 'down'">
              {{ nationalTrend.direction === 'up' ? '↑' : '↓' }} {{ nationalTrend.value }}
            </span>
          }
        </strong>
      </div>
      <div class="summary-comparison">
        <div class="summary-item summary-realized">
          <span class="summary-eyebrow">Última Comissão Realizada</span>
          <strong>{{ lastRealizedCommission }}</strong>
        </div>
        <div class="summary-total">
          <span class="summary-eyebrow">Nova Comissão Simulada</span>
          <strong>
            {{ totalCommission }}
            @if (commissionVariation; as variation) {
              <span
                class="trend"
                [class.trend-up]="variation.direction === 'up'"
                [class.trend-down]="variation.direction === 'down'"
                [class.trend-neutral]="variation.direction === 'stable'"
                [attr.aria-label]="'Variação em relação à última comissão realizada: ' + variation.value">
                {{ variation.direction === 'up' ? '↑ ' : variation.direction === 'down' ? '↓ ' : '' }}{{ variation.value }}
              </span>
            }
          </strong>
        </div>
      </div>
    </footer>
    <span class="visually-hidden" aria-live="polite">{{ updateFeedbackMessage }}</span>
  </div>

  @if (isPenetrationVisible) {
    <section class="panel penetration-panel" id="penetration-table" aria-labelledby="penetration-title">
      <h2 class="panel-title" id="penetration-title">Penetration/ISR</h2>
      <div class="matrix-legend" aria-label="Legenda dos índices na matriz">
        <span class="matrix-legend-item">
          <span class="matrix-legend-swatch matrix-realized-marker" aria-hidden="true"></span>
          Índice realizado
        </span>
        <span class="matrix-legend-item">
          <span class="matrix-legend-swatch matrix-simulated-marker" aria-hidden="true"></span>
          Índice simulado
        </span>
      </div>
      <div class="penetration-table-scroll" [attr.aria-busy]="isPenetrationLoading">
        @if (isPenetrationLoading) {
          <div class="matrix-status" role="status">
            <span class="matrix-loader" aria-hidden="true"></span>
            <span>Carregando matriz...</span>
          </div>
        }
        <table class="penetration-table">
          <thead>
            <tr>
              <th scope="col">Penet / ISR</th>
              @for (column of penetrationColumns; track column) {
                <th scope="col">{{ column }}</th>
              }
            </tr>
          </thead>
          <tbody>
            @for (row of penetrationRows; track row.label; let rowIndex = $index) {
              <tr>
                <th scope="row">{{ row.label }}</th>
                @for (value of row.values; track $index; let columnIndex = $index) {
                  <td
                    [class.matrix-realized-highlight]="isMatrixCell('realized', rowIndex, columnIndex)"
                    [class.matrix-simulated-highlight]="isMatrixCell('simulated', rowIndex, columnIndex)">
                    {{ value }}
                  </td>
                }
              </tr>
            }
          </tbody>
        </table>
      </div>
    </section>
  }
</main>
